import React from "react";
import { Page, NavItem, TabPane } from "components/common";
import { compose } from "recompose";
import { Nav, TabContent } from "reactstrap";
import Table from "./Table";
import { Trans } from "react-i18next";
import { XeroClient } from "services";
import { Link, Switch, Redirect } from "react-router-dom";
import { renderCountSpan } from "services/util";
import { useQuery } from "react-query";

const getTable = (Statuses) => (props) =>
(
  <Table
    filters={{
      extra_params: {
        Statuses,
      },
      raw: 'Type="ACCPAY"',
      Type: "ACCPAY",
    }}
    status={Statuses}
    {...props}
  />
);

const All = getTable("DRAFT,SUBMITTED,AUTHORISED,PAID");
const Draft = getTable("DRAFT");
const AwaitingApproval = getTable("SUBMITTED");
const Approved = getTable("AUTHORISED");
const Paid = getTable("PAID");

export const List = ({ match }) => {
  const xero = XeroClient();

  const { data: counts } = useQuery("invoices/get_pagination_data", () => xero.get("invoices/get_pagination_data", {
    params: {
      raw: `TYPE="ACCPAY"`
    }
  }).get("data"), {
    refetchOnMount: true,
  });

  return (
    <Page className="inv-tabs nw-list">
      <div>
        <div>
          <Link to={`${match.url}/edit/new`} className="btn btn-primary ml-0">
            <span className="fa fa-plus" />
            <span className="mx-1" />
            <Trans>New Bill</Trans>
          </Link>
        </div>
        <Nav tabs className="nw-tabs2 inv-tabs my-3">
          <NavItem to={`all`} translate={false}><Trans>All</Trans> {renderCountSpan(counts?.All?.itemCount)}</NavItem>
          <NavItem to={`draft`} translate={false}><Trans>Draft</Trans> {renderCountSpan(counts?.DRAFT?.itemCount)}</NavItem>
          <NavItem to={`awaiting_approval`} translate={false}><Trans>Awaiting Approval</Trans> {renderCountSpan(counts?.SUBMITTED?.itemCount)}</NavItem>
          <NavItem to={`approved`} translate={false}><Trans>Awaiting Payment</Trans> {renderCountSpan(counts?.AUTHORISED?.itemCount)}</NavItem>
          <NavItem to={`paid`} translate={false}><Trans>Paid</Trans> {renderCountSpan(counts?.PAID?.itemCount)}</NavItem>
        </Nav>
        <TabContent>
          <Switch>
            <TabPane path={`${match.url}/all`} component={All} />
            <TabPane path={`${match.url}/draft`} component={Draft} />
            <TabPane
              path={`${match.url}/awaiting_approval`}
              component={AwaitingApproval}
            />
            <TabPane path={`${match.url}/approved`} component={Approved} />
            <TabPane path={`${match.url}/paid`} component={Paid} />
            <Redirect to={`${match.url}/all`} />
          </Switch>
        </TabContent>
      </div>
    </Page>
  )
};

export const enhance = compose();

export default enhance(List);
